module.exports = __webpack_public_path__ + "static/media/readTogether.b4467fd5.mp3";